export default "__VITE_ASSET__22c316a5__"